/* eslint-disable */
export default {
  feedbackHeader: 'Feedback verzenden',
  back: 'Terug',
  revert: 'Terugdraaien',
  instruction:
    'Uw feedback is waardevol voor ons. Als u problemen hebt met het gebruik van de app, een functie wilt aanvragen of een bug wilt melden, helpen we u graag verder.',
  fillForm: 'Vul het onderstaande formulier in en klik op ',
  useMailBox: ' of gebruik uw mailbox en stuur uw verzoek naar ',
  email: 'Uw e-mailadres',
  reply: '(zodat we u kunnen beantwoorden)',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: 'Onderwerp feedback',
  topicPlaceHolder: 'Selecteer een optie',
  bugReport: 'Melding bug',
  featureRequest: 'Aanvragen functie',
  others: 'Overige',
  subject: 'Onderwerp',
  subjectPlaceHolder: 'Laat ons weten hoe we u kunnen helpen',
  description: 'Volledige omschrijving',
  descriptionPlaceHolder: 'Geef zo veel mogelijk informatie op',
  send: 'Uw feedback verzenden',
} as const;

// @key: @#@"feedbackHeader"@#@ @source: @#@"Submit Feedback"@#@
// @key: @#@"back"@#@ @source: @#@"Back"@#@
// @key: @#@"revert"@#@ @source: @#@"Revert"@#@
// @key: @#@"instruction"@#@ @source: @#@"Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help."@#@
// @key: @#@"fillForm"@#@ @source: @#@"Please fill in the form below and click "@#@
// @key: @#@"useMailBox"@#@ @source: @#@" or directly use your mailbox and send your request to "@#@
// @key: @#@"email"@#@ @source: @#@"Your email address"@#@
// @key: @#@"reply"@#@ @source: @#@"(so we can reply to you)"@#@
// @key: @#@"emailPlaceHolder"@#@ @source: @#@"ronald.app@ringcentral.com"@#@
// @key: @#@"feedbackTopic"@#@ @source: @#@"Feedback topic"@#@
// @key: @#@"topicPlaceHolder"@#@ @source: @#@"Please select an option"@#@
// @key: @#@"bugReport"@#@ @source: @#@"Bug report"@#@
// @key: @#@"featureRequest"@#@ @source: @#@"Feature request"@#@
// @key: @#@"others"@#@ @source: @#@"Others"@#@
// @key: @#@"subject"@#@ @source: @#@"Subject"@#@
// @key: @#@"subjectPlaceHolder"@#@ @source: @#@"Let us know how we can help you"@#@
// @key: @#@"description"@#@ @source: @#@"Full description"@#@
// @key: @#@"descriptionPlaceHolder"@#@ @source: @#@"Please include as much information as possible"@#@
// @key: @#@"send"@#@ @source: @#@"Send Your Feedback"@#@
